export const Select = ({ label, value, onChange, options, helperText, className = '' }) => {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700 drop-shadow-sm">{label}</label>
      <div className="group relative">
        {/* Frosty borders */}
        <div className="absolute left-0 right-0 top-0 h-[1px] rounded-t-lg bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-70"></div>
        <div className="absolute bottom-0 left-0 right-0 h-[1px] rounded-b-lg bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-50"></div>
        <div className="absolute bottom-[10%] left-0 top-[10%] w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent opacity-50"></div>
        <div className="absolute bottom-[10%] right-0 top-[10%] w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent opacity-50"></div>

        <select
          value={value}
          onChange={onChange}
          className="relative z-10 ml-0 w-full appearance-none rounded-lg border border-white/30 bg-white/40 p-3 pr-10 shadow-sm backdrop-blur-md transition-all duration-300 hover:shadow-md focus:border-transparent focus:bg-white/50 focus:shadow-[0_0_0_2px_rgba(255,255,255,0.7),0_0_0_4px_theme(colors.accent-400/30),0_0_15px_theme(colors.accent-400/20)] focus:outline-none"
        >
          {options.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        {/* Custom dropdown arrow with frosty effect */}
        <div className="pointer-events-none absolute inset-y-0 right-0 z-20 flex items-center px-3 text-gray-700">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-white/20 opacity-50 blur-[1px]"></div>
            <svg
              className="relative h-4 w-4 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* Light refraction effect */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-lg">
          <div className="bg-gradient-radial absolute -right-[150%] -top-[150%] h-[300%] w-[300%] rotate-12 from-white/30 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-30"></div>
        </div>
      </div>
      {helperText && <p className="mt-1 text-xs text-gray-500 drop-shadow-sm">{helperText}</p>}
    </div>
  )
}
